<template>
  <div class="app-layout" :style="layoutStyle">
    <el-container class="layout-container" direction="vertical">
      <!-- 顶部Header区域 -->
      <el-header class="layout-header" height="auto">
        <Header ref="headerRef" @show-search-dialog="handleShowSearchDialog" />
      </el-header>

      <!-- 主要内容区域 -->
      <el-container class="main-container">
        <!-- 左侧边栏 - 现在包含我的应用 -->
        <el-aside class="layout-sidebar" :width="sidebarWidth">
          <Sidebar 
            :collapsed="sidebarCollapsed" 
            @toggle-collapse="handleToggleSidebar"
          />
        </el-aside>

        <!-- 右侧主内容区域 -->
        <el-main class="layout-content" :style="contentStyle">
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import Header from './header.vue'
import Sidebar from './sidebar.vue'

export default {
  components: {
    Header,
    Sidebar
  },
  data() {
    return {
      currentBackground: null,
      sidebarCollapsed: false, // 默认展开
      sidebarWidth: '280px' // 默认宽度
    }
  },
  computed: {
    layoutStyle() {
      if (!this.currentBackground) return {
        backgroundColor: '#fff',
        color: '#000'
      };

      const style = {};
      if (this.currentBackground.type === 'solid') {
        style.backgroundColor = this.currentBackground.color;
        style.color = this.currentBackground.textColor;
      } else {
        style.backgroundImage = `url(${this.currentBackground.url})`;
        style.backgroundSize = 'cover';
        style.backgroundPosition = 'center';
        style.backgroundRepeat= 'no-repeat';
        style.backgroundAttachment= 'fixed';
      }
      return style;
    },
    
    contentStyle() {
      return {
        marginLeft: this.sidebarCollapsed ? '64px' : '280px',
        transition: 'margin-left 0.3s ease'
      };
    }
  },
  mounted() {
    this.initBackground();
    this.checkScreenSize();
    window.addEventListener('resize', this.checkScreenSize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenSize);
  },
  methods: {
    initBackground() {
      const savedBg = localStorage.getItem('appBackground');
      if (savedBg) {
        this.currentBackground = JSON.parse(savedBg);
      } else {
        this.currentBackground = {
          title: '默认白色',
          color: '#ffffff',
          textColor: '#000000',
          type: 'solid'
        };
      }
    },
    
    handleShowSearchDialog() {
      console.log('显示搜索对话框');
    },
    
    handleToggleSidebar(collapsed) {
      this.sidebarCollapsed = collapsed;
      this.sidebarWidth = collapsed ? '64px' : '280px';
    },
    
    checkScreenSize() {
      // 在小屏幕上默认收起侧边栏
      if (window.innerWidth < 768) {
        this.sidebarCollapsed = true;
        this.sidebarWidth = '64px';
      }
    }
  }
}
</script>

<style lang="less" scoped>
.app-layout {
  height: calc(100vh - 20px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.layout-container {
  height: 100%;
}

.layout-header {
  padding: 0;
  background: inherit;
  flex-shrink: 0;
}

.main-container {
  height: calc(100vh - 60px);
  overflow: hidden;
  position: relative;
}

.layout-sidebar {
  position: fixed;
  top: 68px;
  left: 0;
  height: calc(100vh - 60px);
  background: #f5f7fa;
  border-right: 1px solid #e4e7ed;
  overflow: hidden;
  transition: width 0.3s ease;
  z-index: 1000;
}

.layout-content {
  padding: 0;
  background: #f0f2f5;
  overflow: auto;
  transition: margin-left 0.3s ease;
  height: 100%;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .layout-sidebar {
    width: 240px !important;
  }
  
  .layout-content {
    margin-left: 240px !important;
  }
}

@media (max-width: 992px) {
  .layout-sidebar {
    width: 200px !important;
  }
  
  .layout-content {
    margin-left: 200px !important;
  }
}

@media (max-width: 768px) {
  .layout-sidebar {
    width: 64px !important;
    transform: translateX(-100%);
    transition: transform 0.3s ease, width 0.3s ease;
  }
  
  .layout-sidebar.mobile-open {
    transform: translateX(0);
  }
  
  .layout-content {
    margin-left: 0 !important;
  }
}
</style>